// extracted by mini-css-extract-plugin
export default {"register":"Register_register__tqnIV","title":"Register_title__Ec+OQ","content":"Register_content__SVvGt","error":"Register_error__x2O4V"};